// This file is auto-generated. Do not edit manually.
// Generated on: 2026-03-25T14:29:32.811Z

/**
 * Application version from package.json
 */
export const VERSION = '0.16.0';

/**
 * Build timestamp
 */
export const BUILD_TIMESTAMP = '2026-03-25T14:29:32.811Z';

/**
 * Returns the application version with build information
 */
export const getVersionString = (): string => {
  return `v${VERSION} (Built: ${new Date(BUILD_TIMESTAMP).toLocaleString()})`;
};
